import { EventName, EventType } from '../constants';
import { createAndSendEvent } from '../jumboClient';

export const SeeMapClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.SEE_MAP_CLICK_EVENT, properties);

export const RecentlyUsedAddressesClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.RECENTLY_USED_ADDRESSES_CLICK_EVENT, properties);

export const LoadMoreAddressesClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.LOAD_MORE_ADDRESSES_CLICK_EVENT, properties);

export const UnmaskAddressClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.UNMASK_ADDRESS_CLICK_EVENT, properties);

export const ViewOnMapClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.VIEW_ON_MAP_CLICK_EVENT, properties);

export const LatLongCopyEvent = (properties = {}) =>
  createAndSendEvent(EventName.LAT_LONG_COPY_EVENT, properties, EventType.COPY);

export const OpenGoogleMapsClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.OPEN_GOOGLE_MAPS_CLICK_EVENT, properties);
